import useCurrentMemberId from '../../members/hooks/index';

const useIsOwnerLifetales = () => {
  const currentMemberId = useCurrentMemberId();
  return currentMemberId === process.env.REACT_APP_LT_MEMBER_ID;
};

export default useIsOwnerLifetales;
